/**
 * Featured image remove control on My Account campaign edit.
 *
 * The upload field only ever adds an image, so the flag input tells the server to clear
 * the stored one. Picking a new file cancels a pending removal.
 */
export default class FeaturedImageRemove {

    init() {
        const container = document.querySelector('.featured-image-container');
        if (!container) {
            return;
        }

        this.container = container;
        this.wrapper = container.querySelector('.chaiathon-campaign-image-wrapper');
        this.flag = container.querySelector('.remove-featured-image-value');
        this.fileInput = container.querySelector('input[type="file"][name="featured_image"]');

        if (!this.wrapper || !this.flag || !this.fileInput) {
            return;
        }

        container.addEventListener('click', (e) => {
            if (e.target.closest('.remove-featured-image-button')) {
                e.preventDefault();
                this.remove();
            }
        });

        this.fileInput.addEventListener('change', () => {
            if (this.fileInput.files?.length) {
                this.flag.value = '';
            }
        });
    }

    remove() {
        this.fileInput.value = '';

        const img = this.wrapper.querySelector('.levcharity-image-preview-host img');
        if (img) {
            if (img.dataset.blobUrl) {
                URL.revokeObjectURL(img.dataset.blobUrl);
            }
            img.remove();
        }

        const name = this.wrapper.querySelector('.levcharity-image-preview-name');
        if (name) {
            name.textContent = '';
        }

        this.wrapper.hidden = true;
        this.flag.value = '1';
        // The save button stays disabled until the form sees a change.
        this.flag.dispatchEvent(new Event('change', { bubbles: true }));
    }
}
